import GetAllRecords from './GetAllRecords';
import Approval from './Approval';
import GetDsoRevenue from './GetDsoRevenue';
import GetAllDsos from './GetAllDsos';
import GetDsoUsers from './GetDsoUsers';
import DeleteDsoUser from './DeleteDsoUser';
import CreateUserInOrganization from './CreateUserInOrganization';
import GetAllUsers from './GetAllUsers';
import OrganizationOwnerUpdate from './OrganizationOwnerUpdate';
import AccountManagerUpdate from './AccountManagerUpdate';
import CampaignPerformanceReport from './CampaignPerformanceReport';
import CampaignSummary from './CampaignSummary';

const Distributors = {
  getAllDistributors: GetAllRecords,
  Approval: Approval,
  getDsoRevenue:GetDsoRevenue,
  getAllDsos:GetAllDsos,
  getDsoUsers:GetDsoUsers,
  deleteDsoUser:DeleteDsoUser,
  createUserInOrganization:CreateUserInOrganization,
  GetAllUsers:GetAllUsers,
  OrganizationOwnerUpdate:OrganizationOwnerUpdate,
  accountManagerUpdate: AccountManagerUpdate,
  campaignPerformanceReport: CampaignPerformanceReport,
  campaignSummary: CampaignSummary,
};

export default Distributors;
